<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div v-if="!isLoaded">
                    <loading-screen :message="'Cargando Información del Proyecto...'" />
                </div>
                <div v-if="isLoaded">
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                <!-- Sección de Título -->
                                <div>
                                    <h6 class="mb-2 ms-2">Detalles del Proyecto: <b>[{{ formData.identifier }}] - {{
                                        formData.project }}</b></h6>
                                </div>
                                <div v-if="projectFound" class="d-flex">
                                    <router-link to="/projects"
                                        class="btn btn-secondary d-flex align-items-center justify-content-center gap-2 mb-0">
                                        <i class="ni ni-bold-left"></i> Regresar
                                    </router-link>
                                    <button class="btn btn-warning mb-0 ms-4" @click="saveProject">Guardar</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="!projectFound" class="d-flex justify-content-center align-items-center"
                                style="height: 50vh;">
                                <div class="text-center">
                                    <i class="bi bi-question-lg text-warning" style="font-size: 3rem;"></i>
                                    <h4 class="fw-bold mt-3">¡Lo sentimos! :c</h4>
                                    <p>No hemos podido encontrar el proyecto solicitado.</p>
                                    <router-link to="/projects" class="btn btn-secondary mt-3">
                                        <i class="ni ni-bold-left"></i> Regresar
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="projectFound && isLoaded">
                                <div class="row mb-2">
                                    <!-- Línea de negocio -->
                                    <div class="col-md-1">
                                        <label class="form-label">Identificador:</label>
                                        <input type="text" class="form-control" id="consecutivo" v-model="formData.tag"
                                            maxlength="3" placeholder="NXN" required>
                                    </div>

                                    <!-- Año -->
                                    <div class="col-md-1">
                                        <label class="form-label">Año:</label>
                                        <input type="number" class="form-control" id="anio" v-model="formData.year"
                                            placeholder="25" min="0" max="99" required>
                                    </div>

                                    <!-- Consecutivo -->
                                    <div class="col-md-1">
                                        <label class="form-label">Consecutivo:</label>
                                        <input type="text" class="form-control" id="consecutivo"
                                            v-model="formData.consecutive" maxlength="4" placeholder="0001" required>
                                    </div>

                                    <!-- Nombre del Proyecto -->
                                    <div class="col-md-4">
                                        <label for="proyecto" class="form-label">Nombre:</label>
                                        <input type="text" class="form-control" id="proyecto" v-model="formData.project"
                                            placeholder="Ejemplo: PRJ001" required>
                                    </div>

                                    <!-- Cliente -->
                                    <div class="col-md-2">
                                        <label for="cliente" class="form-label">Cliente:</label>
                                        <select id="cliente" class="form-select" v-model="selectedClient" required>
                                            <option value="" disabled>{{ formData.client }}</option>
                                            <option v-for="c in clients" :key="c.client_id" :value="c.client_id">
                                                {{ c.client }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Project Manager -->
                                    <div class="col-md-2">
                                        <label for="pm" class="form-label">Project Manager</label>
                                        <select id="pm" class="form-select" v-model="selectedPM" required>
                                            <option value="" disabled>{{ formData.project_manager }}</option>
                                            <option v-for="pm in projectManagers" :key="pm.user_id" :value="pm.user_id">
                                                {{ pm.name }} {{ pm.last_name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-1">
                                        <label for="lineaNegocio" class="form-label">Linea:</label>
                                        <select id="lineaNegocio" class="form-select" v-model="selectedBusinessLine"
                                            required>
                                            <option value="" disabled>{{ formData.business_line }}</option>
                                            <option v-for="linea in businessLines" :key="linea" :value="linea">
                                                {{ linea }}
                                            </option>
                                        </select>

                                    </div>

                                </div>
                                <div class="row mb-2">
                                    <!-- Descripción -->
                                    <div class="col-10">
                                        <label for="descripcion" class="form-label">Descripción</label>
                                        <textarea id="descripcion" class="form-control" rows="4"
                                            v-model="formData.description" placeholder="Descripción del proyecto"
                                            maxlength="255"></textarea>
                                    </div>
                                    <!-- Fechas -->
                                    <div class="col-lg-2">
                                        <label>Fecha de inicio:</label>
                                        <input type="date" class="form-control" v-model="startDate">
                                        <label>Fecha de fin:</label>
                                        <input type="date" class="form-control" v-model="endDate">
                                    </div>
                                </div>
                                <div class="row g-3">

                                    <!-- Reportes Automáticos -->
                                    <div class="col-md-2">
                                        <label class="form-label">Reportes Automáticos</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="reportesAutomaticos"
                                                v-model="formData.automatic_reports">
                                            <label class="form-check-label" for="reportesAutomaticos">
                                                {{ formData.automatic_reports ? 'Activados' : 'Desactivados' }}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Actividad -->
                                    <div class="col-md-6">
                                        <label for="actividad" class="form-label">Actividad por default</label>
                                        <select id="actividad" class="form-select" v-model="selectedActivity"
                                            :disabled="!formData.automatic_reports">
                                            <option value="" disabled>Selecciona Actividad</option>
                                            <option v-for="act in activities" :key="act.activity_id"
                                                :value="act.activity_id">
                                                {{ act.activity }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- En sitio por default -->
                                    <div class="col-md-2 d-flex-">
                                        <label class="form-label">¿En planta por default?</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="enSitio"
                                                v-model="formData.default_on_site"
                                                :disabled="!formData.automatic_reports">
                                            <label class="form-check-label" for="enSitio">
                                                {{ formData.default_on_site ? 'Sí' : 'No' }}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- En sitio por default -->
                                    <div class="col-md-2 d-flex-">
                                        <label class="form-label">¿Proyecto Activo?</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="enSitio"
                                                v-model="formData.active">
                                            <label class="form-check-label" for="enSitio">
                                                {{ formData.active ? 'Sí' : 'No' }}
                                            </label>
                                        </div>
                                    </div>

                                </div>

                                <div v-if="showConfirmation" class="row mt-3">
                                    <div class="col-lg-12 d-flex align-items-center justify-content-between bg-warning px-3"
                                        style="height: 8vh; border-radius: 12px; position: relative;">
                                        <h6 class="mb-0 text-white"><b>Información del proyecto actualizada</b></h6>

                                        <!-- Botón de cerrar -->
                                        <button type="button" class="btn-close btn-close text-white"
                                            @click="showConfirmation = false"></button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div v-if="showUsers" class="card mt-4">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                <div>
                                    <h6 class="mb-2 ms-2">
                                        Colaboradores del Proyecto:
                                        <b>[{{ formData.identifier }}] - {{ formData.project }}</b>
                                    </h6>
                                </div>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="row">

                                <!-- Buscador de usuarios -->
                                <div :class="formData.automatic_reports ? 'col-md-3' : 'col-md-6'">
                                    <h6>Agregar Colaboradores</h6>
                                    <input type="text" class="form-control mb-2" v-model="searchQuery"
                                        placeholder="Buscar usuario..." />
                                    <ul class="list-group">
                                        <li v-for="u in filteredUsers" :key="u.id" class="list-group-item">
                                            <div class="row align-items-center">
                                                <div
                                                    class="col-md-12 d-flex justify-content-between align-items-center">
                                                    <div>
                                                        {{ u.name }}
                                                    </div>
                                                    <div>
                                                        <button class="btn btn-sm btn-warning mb-0" style="width: 20px;"
                                                            @click="addCollaborator(u)">
                                                            <div class="d-flex justify-content-center">
                                                                <i class="bi bi-plus" style="font-size: 1.2rem;"></i>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-if="filteredUsers.length === 0" class="list-group-item text-muted">
                                            No hay usuarios disponibles
                                        </li>
                                    </ul>
                                </div>

                                <!-- Colaboradores actuales -->
                                <div :class="formData.automatic_reports ? 'col-md-9' : 'col-md-6'">
                                    <h6>Colaboradores Asignados</h6>
                                    <ul class="list-group">
                                        <form @submit.prevent="saveProjectUser">
                                            <li v-for="c in collaborators" :key="c.id" class="list-group-item">
                                                <div class="row align-items-center">
                                                    <div class="col-md-3">
                                                        <b>{{ c.name }}</b>
                                                    </div>
                                                    <div
                                                        class="col-md-6 d-flex align-items-center justify-content-center">
                                                        <div v-if="formData.automatic_reports"
                                                            class="d-flex align-items-center justify-content-start">
                                                            <span class="me-2">De:</span>
                                                            <input type="date" class="form-control me-2"
                                                                style="width: 120px; display: block;" required>
                                                            <span class="me-2">a:</span>
                                                            <input type="date" class="form-control"
                                                                style="width: 120px; display: block;" required>
                                                        </div>
                                                        <div
                                                            class="d-flex align-items-center justify-content-start ms-2">
                                                            <span class="me-2">F.C:</span>
                                                            <input type="text" class="form-control form-control-sm"
                                                                placeholder="FC" value="1.0"
                                                                style="width: 50px; display: block;">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 d-flex justify-content-end">
                                                        <button type="submit" class="btn btn-warning mb-0 me-1"
                                                            style="width: 25px;">
                                                            <div class="d-flex justify-content-center">
                                                                <i class="bi bi-floppy"></i>
                                                            </div>
                                                        </button>
                                                        <button class="btn btn-danger mb-0" style="width: 25px;"
                                                            @click="removeCollaborator(c)">
                                                            <div class="d-flex justify-content-center">
                                                                <i class="bi bi-trash"></i>
                                                            </div>
                                                        </button>
                                                    </div>

                                                </div>
                                            </li>
                                        </form>
                                        <li v-if="collaborators.length === 0" class="list-group-item text-muted">
                                            No hay colaboradores asignados
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

const props = defineProps({
    id: {
        type: Number,
        required: true
    }
})

import { ref, onMounted, computed } from 'vue'
import axios from 'axios';
import LoadingScreen from './components/LoadingScreen.vue';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const projectFound = ref(true)
const projectId = ref(props.id)

const startDate = ref('')
const endDate = ref('')
const projectInfoLoaded = ref(false)
const usersInfoLoaded = ref(false)

const isLoaded = ref(false)

const showConfirmation = ref(false)

const verifyIsLoaded = () => {

    if (projectInfoLoaded.value && usersInfoLoaded.value) {
        isLoaded.value = true
    }
}

const selectedBusinessLine = ref('')
const businessLines = [100, 200, 300, 400, 410, 900]

const showUsers = ref(false)

const formData = ref({})

const selectedClient = ref('')
const selectedPM = ref('')
const selectedActivity = ref('')

const activities = ref([])
const projectManagers = ref([])
const clients = ref([])

const projectUsers = ref([])

const formatDate = (date) => { return date.split('T')[0]; }

const validateProjectId = (id) => {
    const idNumber = parseInt(id, 10)
    if (isNaN(idNumber) || !Number.isInteger(idNumber)) {
        projectFound.value = false
    }
}

const getProjectInfo = async () => {

    const body = { project_id: projectId.value }
    try {
        const response = await axios.post(`${API_BASE_URL}/complete-project-info`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            formData.value = response.data
            const tag = response.data.identifier?.slice(0, 3)
            const allowed = ['100', '200', '300', '400', '410', '900', 'NXN']
            if (allowed.includes(tag)) {
                formData.value.tag = tag
            }
            if (formData.value.start_date && formData.value.end_date) {
                startDate.value = formatDate(formData.value.start_date)
                endDate.value = formatDate(formData.value.end_date)
            } else {
                startDate.value = ''
                endDate.value = ''
            }
            projectInfoLoaded.value = true
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}


const getClients = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/clients`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        clients.value = response.data;
    } catch (error) {
        console.error("Error al cargar clientes:", error);
    }
};

const getActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        activities.value = response.data;
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const getPMs = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-project-managers`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        projectManagers.value = response.data;
    } catch (error) {
        console.error("Error al cargar clientes:", error);
    }
}

const saveProjectUser = async (id, start, end, bf) => {
    console.log('usuario del proyecto guardado: ', id, start, end, bf)
}

const saveProject = async () => {

    let identifier = `${formData.value.tag}-${formData.value.year}-${formData.value.consecutive}`

    const submitFormData = {
        business_line: formData.value.business_line,
        client_id: selectedClient.value || formData.value.client_id,
        pm_id: selectedPM.value || formData.value.pm_id,
        default_activity_id: selectedActivity.value || formData.value.default_activity_id,
        identifier: identifier,

        project_id: projectId.value,
        project: formData.value.project,
        year: formData.value.year,
        consecutive: formData.value.consecutive,
        description: formData.value.description,
        start_date: startDate.value,
        end_date: endDate.value,
        automatic_reports: formData.value.automatic_reports,
        default_on_site: formData.value.default_on_site,
        active: formData.value.active
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/edit-complete-project`, submitFormData, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status == 200 && response.data.success) {
            // Mostrar el mensaje
            showConfirmation.value = true
            // Ocultarlo después de 3 segundos
            setTimeout(() => {
                showConfirmation.value = false
            }, 3000)
        }
    } catch (error) {
        console.error('Error al actualizar el proyecto:', error);
        alert('Error al actualizar el proyecto:', error)
    }

}

const fetchProjectUsers = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/project-users`, { project_id: projectId.value }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        projectUsers.value = response.data;
        usersInfoLoaded.value = true
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
}


// Usuarios ya asignados al proyecto
const collaborators = ref([
    { id: 1, name: "Juan Pérez", factor: 1.0 },
    { id: 2, name: "María López", factor: 0.6 }
]);

// Lista de todos los usuarios disponibles
const allUsers = ref([
    { id: 1, name: "Juan Pérez" },
    { id: 2, name: "María López" },
    { id: 3, name: "Carlos Ramírez" },
    { id: 4, name: "Ana Torres" },
    { id: 5, name: "Pedro Sánchez" }
]);

// Buscador
const searchQuery = ref("");

// Filtrar usuarios que no estén en colaboradores y coincidan con el buscador
const filteredUsers = computed(() => {
    return allUsers.value.filter(
        u =>
            !collaborators.value.some(c => c.id === u.id) &&
            u.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
});

// Funciones
const addCollaborator = (user) => {
    collaborators.value.push(user);
};

const removeCollaborator = (user) => {
    collaborators.value = collaborators.value.filter(c => c.id !== user.id);
};


onMounted(async () => {
    validateProjectId(projectId.value)
    getPMs()
    await getActivities()
    await getClients()
    await getProjectInfo()
    await fetchProjectUsers()
    verifyIsLoaded()
})

</script>